import { Truck } from 'lucide-react';
import { useState } from 'react';

import type { FotoNaLista } from './frota';

/**
 * A identidade visual da maquina na linha da tabela (p.14): "foto real do
 * proprio ativo em recorte quadrado de 32 px, OU o icone Lucide do tipo de
 * equipamento".
 *
 * A CAIXA E SEMPRE A MESMA — 32 x 32, raio do selo —, com foto ou sem. Assim
 * as linhas alinham numa lista em que so metade das maquinas tem foto, e o
 * texto da celula nao anda de lugar quando a miniatura chega.
 *
 * Sem foto, sem miniatura ainda, ou com a URL assinada vencida (`onError`), a
 * caixa mostra `truck`: e a entrada de "equipamento / ativo" do vocabulario
 * normativo, a unica que existe para maquina. Nenhum icone novo de "foto" ou
 * "camera" — seria conceito fora do vocabulario.
 *
 * `alt` vazio de proposito: o codigo e o tipo da maquina estao escritos ao
 * lado, e o leitor de tela diria o mesmo duas vezes.
 */
export function MiniaturaDoEquipamento({ foto }: { readonly foto: FotoNaLista | null }) {
  /* Guarda a URL que falhou, e nao um booleano: a lista seguinte traz URL
     nova, assinada de novo, e ela merece nova tentativa. */
  const [falhou, setFalhou] = useState<string | null>(null);
  /* Ate a miniatura abrir, a caixa e esqueleto (p.32), e nao um quadrado
     cinza parado que se le como "sem foto". */
  const [aberta, setAberta] = useState<string | null>(null);
  const url = foto?.miniaturaUrl ?? null;

  if (url !== null && url !== falhou) {
    return (
      <img
        src={url}
        alt=""
        width={32}
        height={32}
        loading="lazy"
        decoding="async"
        className={`size-8 shrink-0 rounded-badge object-cover ${aberta === url ? 'bg-rebaixada' : 'esqueleto'}`}
        onLoad={() => {
          setAberta(url);
        }}
        onError={() => {
          setFalhou(url);
        }}
      />
    );
  }

  return (
    <span className="flex size-8 shrink-0 items-center justify-center rounded-badge bg-rebaixada">
      <Truck className="size-[var(--icone-controle)] shrink-0" />
    </span>
  );
}
